/**
 * @generated SignedSource<<1499d4a458b2d2e8e4d7ff555e6d3883>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow747BadPattern$data = {
  readonly __id: string;
  readonly issueId: string;
  readonly issueTypeField?: {
    readonly issueType: {
      readonly hierarchy?: {
        readonly level: number | null | undefined;
      } | null | undefined;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"IssueKeyCell59BadPattern" | "IssueSummaryCell179BadPattern" | "RichTextCell138BadPattern">;
  readonly " $fragmentType": "IssueRow747BadPattern";
};
export type IssueRow747BadPattern$key = {
  readonly " $data"?: IssueRow747BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow747BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow747BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueTypeHierarchyLevel",
                  "kind": "LinkedField",
                  "name": "hierarchy",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "level"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueSummaryCell179BadPattern"
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueKeyCell59BadPattern"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RichTextCell138BadPattern"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "91636c173b04d85de83a6dcc50ce390c";

export default node;
